'use client';

import { c as _c } from "react/compiler-runtime";
import { useAtomValue } from 'jotai';
import { Home } from 'lucide-react';
import { Fragment } from 'react';
import * as React from 'react';
import { userIdAtom } from '@/atoms/auth';
import { ArrowOutwardRounded } from '@/components/icons/arrow';
import { NavMain } from '@/components/nav-main';
import { NavSecondary } from '@/components/nav-secondary';
import { Separator } from '@/components/ui/separator';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarMenu, SidebarMenuBadge, SidebarMenuButton, SidebarMenuItem, SidebarRail, SidebarTrigger } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
const data = {
  navMain: [{
    title: 'Home',
    url: '/',
    icon: <Home />
  }],
  navSecondary: [{
    title: 'Vocabulary',
    url: '/mine/vocabulary',
    icon: <svg className="icon-[solar--checklist-bold]" />
  }, {
    title: 'Chart',
    url: '/mine/chart',
    icon: <svg className="icon-[material-symbols--bar-chart-4-bars]" />
  }],
  navFooter: [{
    title: 'About',
    url: '/about',
    icon: <svg className="icon-[material-symbols--info-outline]" />
  }]
};
const accountNav = [{
  title: 'User',
  url: '/user/profile',
  icon: <svg className="icon-[lucide--user-round-pen]" />
}, {
  title: 'Password',
  url: '/user/password',
  icon: <svg className="icon-[akar-icons--key]" />
}];
export function AppSidebar(t0) {
  const $ = _c(22);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const userId = useAtomValue(userIdAtom);
  let t1;
  if ($[3] !== className) {
    t1 = cn("border-r-0", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SidebarHeader className="gap-1.5"><SidebarTrigger className="size-8" /><NavMain items={data.navMain} /></SidebarHeader>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex w-full"><Separator className="mx-3 shrink" /></div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NavMain items={data.navSecondary} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== userId) {
    t5 = userId ? <Fragment><Separator className="min-h-px shrink" /><NavMain items={accountNav} /></Fragment> : null;
    $[8] = userId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <SidebarContent className="p-2">{t4}{t5}</SidebarContent>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex w-full"><Separator className="mx-3 shrink" /></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="sr-only">Subvocab on GitHub</span>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="size-4 shrink-0 bg-sidebar group-hover/bg:bg-inherit"><span className="icon-[bi--github] size-full" /></span>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SidebarMenuButton asChild={true}><a href="/github" target="_blank" className="group/bg block px-2 *:z-10" rel="noreferrer noopener">{t8}{t9}<span className="grow"><span className="bg-sidebar group-hover/bg:bg-inherit">GitHub</span></span></a></SidebarMenuButton>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SidebarFooter><SidebarMenu><SidebarMenuItem className="flex">{t10}<SidebarMenuBadge><ArrowOutwardRounded /></SidebarMenuBadge></SidebarMenuItem></SidebarMenu><NavSecondary items={data.navFooter} className="mt-auto p-0" /></SidebarFooter>;
    t12 = <SidebarRail />;
    $[16] = t11;
    $[17] = t12;
  } else {
    t11 = $[16];
    t12 = $[17];
  }
  let t13;
  if ($[18] !== props || $[19] !== t1 || $[20] !== t6) {
    t13 = <Fragment><Sidebar className={t1} {...props}>{t2}{t3}{t6}{t7}{t11}{t12}</Sidebar></Fragment>;
    $[18] = props;
    $[19] = t1;
    $[20] = t6;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}